<template>
  <div>
    <v-card-title>
      <v-row class="py-2">
        <v-col lg="6" md="6" sm="8" class="col-12">
          <v-menu ref="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-combobox
                v-model="dateRangeText"
                label="Rango Fechas"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
              ></v-combobox>
            </template>
            <v-date-picker v-model="dates" range no-title scrollable color="primary"> </v-date-picker>
          </v-menu>
        </v-col>
        <v-spacer></v-spacer>
        <v-col lg="2" md="2" sm="2" class="col-12">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn class="mx-4" v-on="on" fab dark small color="primary" @click="exportar()">
                <v-icon small dark>fas fa-arrow-alt-circle-down</v-icon>
              </v-btn>
            </template>
            <span>Exportar</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="listadoAsistencia"
      class="elevation-0 border"
      item-key="idasistencia"
      multi-sort
      :mobile-breakpoint="0"
      no-data-text="No se encontraron datos"
      no-results-text="No se encontraron datos"
      :items-per-page="pagina"
    >
    </v-data-table>
  </div>
</template>

<script>
import AsistenciaService from '../services/AsistenciaService';
import moment from 'moment';

export default {
  name: 'AsistenciaLista',
  data: () => ({
    dates: [],
    asistenciaService: null,
    headers: [
      { text: 'estacion', value: 'idestacion', width: '150' },
      { text: 'sector', value: 'idsectorpadre', width: '150' },
      { text: 'bloque', value: 'idsector', width: '150' },
      { text: 'semana', value: 'semana', width: '150' },
      { text: 'turno', value: 'idturno', width: '150' },
      { text: 'planilla', value: 'idplanilla', width: '150' },
      { text: 'trabajador', value: 'idtrabajador', width: '150' },
      { text: 'nombresall', value: 'nombresall', width: '400' },
      { text: 'sexo', value: 'sexo', width: '150' },
      { text: 'fecha', value: 'fecha', width: '150' },
      { text: 'horaingreso', value: 'horaingreso', width: '150' },
      { text: 'horasalida', value: 'horasalida', width: '150' },
      { text: 'observaciones', value: 'observaciones', width: '150' }
    ],
    listadoAsistencia: [],
    cont: 0,
    txtEstado: ''
  }),
  computed: {
    pagina() {
      if (screen.width <= 600) return 5;
      else return 15;
    },
    dateRangeText() {
      return this.dates.join(' ~ ');
    }
  },
  watch: {
    dates(val) {
      if (val.length <= 1) return;
      this.iniciaListado();
    }
  },
  methods: {
    open() {
      this.$emit('open');
    },
    close() {
      this.$emit('close');
    },
    async iniciaListado() {
      this.open();
      this.listadoAsistencia = [];
      const res = await this.asistenciaService.get().execResource('asistencia', {
        idempresa: localStorage.getItem('emp'),
        fechaInicio: Date.parse(this.dates[0]) < Date.parse(this.dates[1]) ? this.dates[0] : this.dates[1],
        fechaFin: Date.parse(this.dates[1]) > Date.parse(this.dates[0]) ? this.dates[1] : this.dates[0]
      });
      if (res.length > 0) {
        this.listadoAsistencia = res;
      }
      this.close();
    },
    exportar() {
      const token = localStorage.getItem('token');
      const empresa = localStorage.getItem('emp');
      const url = `http://165.227.60.116:8005/api/v1/unidadcampamento/`;
      const uri = `excelrptasistenciacampamento?idempresa=${empresa}&fechaInicio=${
        Date.parse(this.dates[0]) < Date.parse(this.dates[1]) ? this.dates[0] : this.dates[1]
      }&fechaFin=${
        Date.parse(this.dates[1]) > Date.parse(this.dates[0]) ? this.dates[1] : this.dates[0]
      }&token=${token}`;
      window.location.href = `${url}${uri}`;
    }
  },
  async mounted() {
    this.asistenciaService = this.$httpService(new AsistenciaService(), this);
    this.dates = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
  }
};
</script>
